"use client";

import AOS from "aos";
import { useEffect } from "react";

import "aos/dist/aos.css";

import CountdownTimer from "@/components/ui/count-down-timer";
import Footer from "@/components/ui/footer";
import Header from "@/components/ui/header";

export default function DefaultLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  });

  return (
    <>
      <CountdownTimer />
      <Header />

      <main className='grow relative'>{children}</main>

      <Footer />
    </>
  );
}
